import useSWRMutation from "swr/mutation";
import { TypedDocumentString } from "../generated/graphql";
import graphQLFetcher from "../index";

// Hand-written ahead of codegen: `deleteLibertyAIConversation` isn't on the
// deployed schema yet, so it can't come from `../generated/graphql` the way
// `useSendLibertyAIMessage` does. Once the mutation ships and `pnpm codegen`
// picks it up, delete this file's local Document/types and import the
// generated `DeleteLibertyAiConversationDocument` ones instead -- the shape
// here is written to match exactly.
export interface DeleteLibertyAiConversationMutationVariables {
  id: string;
}

export interface DeleteLibertyAiConversationMutation {
  __typename?: "Mutation";
  deleteLibertyAIConversation: boolean;
}

const DeleteLibertyAiConversationDocument = new TypedDocumentString(`
    mutation DeleteLibertyAIConversation($id: ID!) {
  deleteLibertyAIConversation(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteLibertyAiConversationMutation,
  DeleteLibertyAiConversationMutationVariables
>;

export interface UseDeleteLibertyAIConversationResponse {
  deleteLibertyAIConversation: (
    variables: DeleteLibertyAiConversationMutationVariables,
  ) => Promise<DeleteLibertyAiConversationMutation | undefined>;
  loading: boolean;
  error: Error | undefined;
}

export function useDeleteLibertyAIConversation(): UseDeleteLibertyAIConversationResponse {
  const { error, isMutating, trigger } = useSWRMutation<
    DeleteLibertyAiConversationMutation,
    Error,
    string,
    DeleteLibertyAiConversationMutationVariables
  >(
    "deleteLibertyAIConversation",
    async (_key, { arg }: { arg: DeleteLibertyAiConversationMutationVariables }) => {
      return graphQLFetcher(DeleteLibertyAiConversationDocument, arg);
    },
  );

  return {
    deleteLibertyAIConversation: trigger,
    loading: isMutating,
    error,
  };
}
